import { RewardNotification } from '../hooks/useRewardNotifications';

export interface BadgeNotification {
  type: 'badge';
  id: string;
  badgeName: string;
  badgeIcon: string | null;
  currentTierName: string | null;
  currentTierImage: string | null;
  visitCount: number;
  restaurantName: string | null;
}

export type AnyRewardNotification = RewardNotification | BadgeNotification;

interface Props {
  notification: AnyRewardNotification;
  queueLength: number;
  onDismiss: () => void;
  onViewPassport?: () => void;
}

export function RewardPopup({ notification, queueLength, onDismiss, onViewPassport }: Props) {
  const isAchievement = notification.type === 'achievement';
  // Cast to a combined shape to access all fields safely
  type CombinedShape = {
    type: string;
    id: string;
    name?: string;
    description?: string;
    icon?: string | null;
    points?: number;
    badgeName?: string;
    badgeIcon?: string | null;
    currentTierName?: string | null;
    currentTierImage?: string | null;
    visitCount?: number;
    restaurantName?: string | null;
  };
  const n = notification as CombinedShape;

  const iconSrc = isAchievement ? n.icon : (n.currentTierImage ?? n.badgeIcon);
  const title = isAchievement ? (n.name ?? '') : (n.badgeName ?? '');
  const subtitle = isAchievement ? (n.description ?? '') : n.currentTierName ? `${n.currentTierName} · ${n.restaurantName ?? ''}` : (n.restaurantName ?? '');
  const label = isAchievement ? ' Достижение разблокировано!' : ' Бейдж получен!';
  const points = isAchievement ? `+${n.points ?? 0} pts` : `Посещений: ${n.visitCount ?? 0}`;

  return (
    <div className="ach-unlock-overlay" onClick={onDismiss}>
      <div className="ach-unlock-popup" onClick={(e) => e.stopPropagation()}>
        <div className="ach-unlock-tag">{label}</div>
        <div className="ach-unlock-icon">
          {iconSrc?.startsWith('http') ? (
            <img src={iconSrc} alt={title} style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 12 }} />
          ) : (
            <span style={{ fontSize: 48 }}>{iconSrc || (isAchievement ? '' : '')}</span>
          )}
        </div>
        <div className="ach-unlock-name">{title}</div>
        <div className="ach-unlock-desc">{subtitle}</div>
        <div className="ach-unlock-pts">{points}</div>
        {queueLength > 1 && (
          <div className="ach-unlock-more">+{queueLength - 1} ещё</div>
        )}
        <div className="ach-unlock-actions">
          {onViewPassport && (
            <button className="ach-btn-secondary" onClick={onViewPassport}>
              Смотреть в паспорте
            </button>
          )}
          <button className="ach-btn-primary" onClick={onDismiss}>
            Понятно
          </button>
        </div>
      </div>
    </div>
  );
}
